import React from 'react';
import { Box, Typography, Grid, useTheme, useMediaQuery } from '@mui/material';

const Outcome = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box pt={'4rem'} textAlign={'center'} alignItems={'center'}>
            <Grid container spacing={5} py={'3rem'}>
                <Grid item xs={12} md={6} py={2} textAlign={'center'} mx={3}>
                    <Typography
                        variant="h4"
                        fontFamily={"'Raleway',sans-serif;"}
                    >
                        Become The Man She Needs
                    </Typography>
                    <Typography variant="h6" textTransform={'uppercase'}>
                        START BUILDING A RELATIONSHIP THAT WILL LAST
                    </Typography>
                    <Typography
                        variant="body1"
                        py={5}
                        px={2}
                        textAlign={'left'}
                        maxWidth={'1024px'}
                    >
                        Imagine how life will feel when you no longer have fears
                        and insecurities holding you back from being the man she
                        needs. Imagine how it will feel to have a guide by your
                        side every step of the way, no longer feeling lost or
                        hopeless.
                        <br />
                        <br />
                        Nothing changes if nothing changes. If you want
                        different results you're going to have to take different
                        action.
                        <br />
                        <br />
                        No more wasting time. Stop letting fear and insecurities
                        control you. Become the man she needs before it's too
                        late!
                        <br />
                        <br />
                        Stop the struggle, book a free Renewed Relationship
                        Session today and turn your relationship around.
                        <br />
                        <br />
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={4}
                    textAlign={isMobile ? 'center' : 'right'}
                >
                    <img
                        src="\images\success.jpg"
                        alt="Success"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            padding: 0,
                            margin: 0,
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Outcome;
